import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../../services/tools/helpers.service';
import { ReportsHelperService } from '../../../services/tools/reports-helpers.service';
import { ReportesConveniosService } from "../../../services/reportes/reportes-convenios.service";
import { ConveniosService } from "../../../services/convenios.service";

@Component({
    selector: 'app-reporte-convenios-general',
    templateUrl: './reporte-convenios-general.component.html'
  })

export class ReporteConveniosGeneralComponent implements OnInit {
    public reportData: any [] = [];
    public totales: any = {};
    public convenios: any[] = [];
    //Filtros
    public convenioSelected: any = {};
    //Helpers
    public isLoading: boolean = true;
    public areConveniosLoading: boolean = true;
    public isItemsArrayEmpty: boolean = null;

    constructor(
        private helperService: HelpersService,
        public helper: ReportsHelperService,
        private reportesService: ReportesConveniosService,
        private conveniosService: ConveniosService
    ){

    }

    public ngOnInit() {
        this.updateReporte();
        this.getConvenios();
    }

    public updateReporte(){

        let filters = this.getFiltros();

        //Mostrar el ajax loading
        this.isLoading = true;

        this.reportesService.getReporteGeneral(filters).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                let items = [];
                let totales = {};

                if(jsonResult.content ){
                    if(jsonResult.content.items){
                        items = jsonResult.content.items;
                    }
                    if(jsonResult.content.totales){
                        totales = jsonResult.content.totales;
                    }
                }

                this.reportData = items;
                this.totales = totales;
                this.isLoading = false;
                this.isItemsArrayEmpty = this.reportData.length == 0;
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    private getFiltros(){
        let filters = {
            convenio: (this.convenioSelected && this.convenioSelected.id ? this.convenioSelected.id : null )
        }

        return filters;
    }

    public print(){
        //Imprimir pantalla
        window.print();
    }

    public getConvenios(){    
        this.conveniosService.getAll({ paginate : false, order : 'razon_social' }).subscribe(
            (response)=>
            {
            const jsonResult = response.json();
            if(jsonResult.content){
                this.convenios = response.json().content;
                this.areConveniosLoading = false;
            }
            
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public onSelectedPromotor(convenio: any){
        this.convenioSelected = convenio;
        this.updateReporte();
    }

    public descargar() {

        let filters = this.getFiltros();

        this.reportesService.exportReporteGeneralToExcel(filters).subscribe(
            (response)=>
            {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/convenios/general/reporte-convenios-general.component.ts